<form [formGroup]="formGroup()" (ngSubmit)="login()">
  <div class="main-content">
    <div class="login-form">
      <p class="login-form-info">Podaj swój login oraz hasło do portalu.</p>
      <div class="flex flex-col gap-2">
        <label for="login">Login</label>
        <input
          id="login"
          pInputText
          appControlError
          formControlName="username"
        />
      </div>
      <div class="flex flex-col gap-2">
        <label for="password">Hasło</label>
        <input
          id="password"
          type="password"
          pInputText
          appControlError
          formControlName="password"
        />
      </div>
      <div class="flex justify-between mt-4">
        <p-button
          styleClass="customInfoButton outlined"
          size="small"
          type="button"
          (click)="navigateToLoginMethod(); $event.preventDefault()"
          [label]="'Wstecz'"
        />
        <p-button
          styleClass="customInfoButton"
          size="small"
          type="submit"
          [label]="'Zaloguj'"
        />
      </div>
    </div>
  </div>
</form>
